/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  currentSearch selectors
 */

import type { State } from '@zcode/state-type'
import { compose } from 'redux'

export const selectCurrentSearch = (state: State) => state.currentSearch

export const selectLocation = compose((state) => state.location, selectCurrentSearch)

export const selectListables = compose((state) => state.listables, selectCurrentSearch)

export const selectAllNearbyHoods = compose(
  (currentSearch) => currentSearch.allNearbyHoods,
  selectCurrentSearch
)

export const selectListablesMatching = compose((state) => state.matching, selectListables)

export const selectIsFromPaidMarketing = compose(
  (currentSearch) => currentSearch.isFromPaidMarketing,
  selectCurrentSearch
)

export const selectUrl = compose((state) => state.url, selectLocation)

export const selectBox = compose((state) => state.box, selectLocation)

export const selectNearbyHoods = compose(
  (allNearbyHoods) => allNearbyHoods?.nearbyHoods,
  selectAllNearbyHoods
)

export const selectListablesCountsByPrice = compose(
  (currentSearch) => currentSearch.countsBy?.minPrice,
  selectCurrentSearch
)
